<template>
    <div
        class="ask-pendo-artifact-card"
        :class="{ active }"
        @click="$emit('click')">
        <pendo-icon
            :type="getArtifactIcon(artifact)"
            size="16px" />
        <div class="ask-pendo-artifact-card__body">
            <span
                class="ask-pendo-artifact-card__title"
                :title="getArtifactTitle(artifact)">
                {{ getArtifactTitle(artifact) }}
            </span>
            <span
                v-if="active"
                class="ask-pendo-artifact-card__subtitle">
                {{ $t('askPendo.Viewing') }}
            </span>
        </div>
        <ask-pendo-toolbar-menu
            icon="more-horizontal"
            placement="bottom-start"
            :items="menuItems" />
    </div>
</template>

<script>
import { PendoIcon } from '@pendo/components';
import { getArtifactIcon, getArtifactTitle } from '@/ask-pendo/artifacts/artifact.utils';
import AskPendoToolbarMenu from '@/ask-pendo/components/ask-pendo-toolbar-menu.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'AskPendoArtifactCard',
    components: {
        AskPendoToolbarMenu,
        PendoIcon,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        artifact: {
            type: Object,
            required: true,
        },
    },
    emits: ['click'],
    computed: {
        ...mapGetters('askPendo', ['getArtifactMenuItems']),
        artifactId () {
            return this.artifact?.artifact_id;
        },
        menuItems () {
            return this.artifactId ? this.getArtifactMenuItems(this.artifactId) : [];
        },
    },
    methods: {
        getArtifactIcon,
        getArtifactTitle,
    },
};
</script>

<style scoped lang="less">
.ask-pendo-artifact-card {
    display: flex;
    align-items: center;
    margin-top: 12px;
    padding: 12px;
    gap: 16px;
    width: 100%;
    border-radius: 4px;
    border: 1px solid var(--palette-gray-30);
    background-color: var(--palette-gray-0);
    cursor: pointer;

    &:hover {
        border-color: var(--palette-teal-80);
    }

    &.active {
        border-color: var(--palette-teal-80);
        box-shadow: 0 4px 8px 0 var(--semantic-drop-shadow-base);
    }

    &__header {
        display: flex;
        gap: 4px;
        align-items: center;
        font-size: 12.642px;
    }

    &__body {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    &__title {
        font-weight: 600;
        line-height: 1.5;
    }

    &__subtitle {
        font-size: 11px;
        line-height: 1.5;

        color: var(--palette-gray-70);
    }
}
</style>
